import styled from 'styled-components/native'
import { View } from 'react-native'
import { ProximaNova } from '../../../App/Components'
import StyleVariables from '../../../StyleVariables'

export const PriceContainer = styled(View)<{
  fontColor: string
}>`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  border: ${({ fontColor }) =>
    `1px solid ${fontColor || StyleVariables.colorBlack}`};
  border-radius: ${StyleVariables.borderRadiusCard};
  padding: ${StyleVariables.cardPadding};
  width: calc(100% - 40px);
  max-width: ${StyleVariables.cardMaxWidth};
  margin: ${StyleVariables.cardMargin};
  align-self: center;
`

export const AmountContainer = styled(View)`
  display: flex;
  flex-direction: row;
`

export const AmountText = styled(ProximaNova)<{
  fontColor: string
}>`
  color: ${({ fontColor }) => fontColor || StyleVariables.colorBlack};
  font-size: ${StyleVariables.fontSizeBase};
`

export const Price = styled(ProximaNova)<{
  fontColor: string
}>`
  color: ${({ fontColor }) => fontColor || StyleVariables.colorBlack};
  font-size: ${StyleVariables.fontSizeBase};
  margin-left: 8px;
  font-weight: 600;
`

export const DepositContainer = styled(View)<{
  hasMarginTop?: boolean
}>`
  display: flex;
  flex-direction: row;
  ${({ hasMarginTop }) => (hasMarginTop ? 'margin-top: 8px;' : '')}
`
